import { history } from '../redux/store';

export function navigateEmployeeHome() {
  history.push('/vertical/CovidVaccination');
}
